// Mod_Level.ts — the Level modifier (Buildings Set1, §2.3).
//
// A Level owns a whole subtree of Rooms (its descendants); the level's resolved
// `floorThickness`/`wallHeight` (through the §3 fallback chain) determine the storey height. The
// `floorNumbers` list is what lets ONE "prototype" level populate many unexplored floors of a
// tower (the UI has an auto-fill X..Y button).
import {BuildingMaterials} from "./Building/BuildingShared.js";

export class Mod_Level {
	constructor(data?: Partial<Mod_Level>) { Object.assign(this, data); }

	/** 1-based floor numbers this level's whole subtree is instantiated at.
	 *  Empty/null => [1]. 0 is INVALID (basements are -1, -2, ...) and is dropped with a warning. */
	floorNumbers: number[] = [1];

	floorThickness?: number|n;
	wallHeight?: number|n;
	/** Default wall thickness for every room on this level's floors (Set2 §4.1). Slots into the §3.3 chain BETWEEN the room's own `Mod_Room.wallThickness` and the building default. It maps onto the `room.wallThickness` leaf (there is one wall-thickness concept; the level is simply a nearer source), so `ResolveRoomParams(roomObj).wallThickness` already returns the level-aware value. */
	wallThickness?: number|n;
	materials?: n|BuildingMaterials;
}
